import { z } from 'zod'

export const AWS_PIPELINE_STATUS = {
  PROVISIONED: 'PROVISIONED',
  PROVISIONING: 'PROVISIONING',
  UNPROVISIONED: 'UNPROVISIONED',
  FAILED: 'FAILED',
  FAILED_TO_FETCH: 'FAILED TO FETCH STATUS',
  DELETING: 'DELETING'
}

const MediaLiveChannel = z.object({
  state: z.union([z.literal('CREATED'), z.literal('RUNNING')]),
  videoNotDetected: z.boolean().nullable(),
  audioNotDetected: z.boolean().nullable()
})

const MediaConnectFlow = z.object({
  status: z.union([
    z.literal('STARTING'),
    z.literal('ACTIVE'),
    z.literal('UPDATING'),
    z.literal('STARTING')
  ])
})

export const GetEventPipelineStatusParser = z.object({
  pipelineKey: z.string(),
  region: z.string(),
  flows: z.array(MediaConnectFlow),
  channels: z.array(MediaLiveChannel),
  inputType: z.union([z.literal('RTMP'), z.literal('ZIXI'), z.literal('SRT')]).nullable(),
  ipAddress: z.string().nullable(),
  pipelineStatus: z.union([
    z.literal('PROVISIONING'),
    z.literal('PROVISIONED'),
    z.literal('UNPROVISIONED'),
    z.literal('FAILED'),
    z.literal('FAILED TO FETCH STATUS'),
    z.literal('DELETING')
  ]),
  live: z.boolean()
})

export type EventPipelineStatus = z.infer<typeof GetEventPipelineStatusParser>
